import React from 'react';
import './AlertDialog.css';

interface AlertDialogProps {
  message: string;
  onClose: () => void;
}

export const AlertDialog = ({ message, onClose }: AlertDialogProps) => {
  // Prevent clicks inside the modal from closing it
  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className="alert-backdrop" onClick={onClose}>
      <div className="alert-modal" onClick={handleModalClick}>
        <p className="alert-message">{message}</p>
        <div className="alert-actions">
          <button className="btn-ok" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};